<template>
  <b-modal :id="`ModalLimparCenario${id}`">
    <Header mini titulo="limpar cenário" icone="eraser" cor="azul" slot="modal-header"/>
    <template>
      <div class="modal-corpo">Tem certeza que deseja limpar seu cenário?</div>
    </template>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="cancelar"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Limpar"
        icone="check"
        :click="handleClick"
        cor="azul"
      />
    </template>
  </b-modal>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";

export default {
  name: "ModalLimpar",
  components: {
    BotaoPadrao,
    Header
  },
  props: {
    limpaDadosForm: Function,
    id: Number
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },

  methods: {
    handleKey(event) {
      let modal = document.getElementById(`ModalLimparCenario${this.id}`);
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          this.limpaDadosForm();
          this.$root.$emit("bv::hide::modal", `ModalLimparCenario${this.id}`);
        }
      }
    },
    handleClick() {
      this.limpaDadosForm();
      this.$root.$emit("bv::hide::modal", `ModalLimparCenario${this.id}`);
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", `ModalLimparCenario${this.id}`);
    }
  }
};
</script>

<style lang="scss">
.modal-cabecalho {
  display: flex;
  flex-direction: column;
  align-items: center !important;
  justify-content: center;
}
.modal-cabecalho-interno {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.modal-icone-limpar {
  font-size: 40px;
  margin: 5px 0;
  color: var(--azul2);
}
.modal-corpo {
  text-align: center;
}
.botao-modal {
  margin: 0 0 0 10px !important;
}
</style>
